import PropTypes from 'prop-types';
import Anchor from 'sd-ui/dist/commonjs/components/Anchor/Anchor';
import CentredComponentContainer from './centredComponentContainer';

export default function ErrorMessage({ fallbackUrl }) {
  return (
    <CentredComponentContainer>
      Something went wrong.&nbsp;
      <Anchor href={fallbackUrl}>Return to article.</Anchor>
    </CentredComponentContainer>
  );
}

ErrorMessage.propTypes = {
  fallbackUrl: PropTypes.string.isRequired,
};
